export default __webpack_public_path__ + "static/media/Funkytown.9eff7bf8.ttf";